import { Pipe, PipeTransform } from '@angular/core';
import { TranslateForCrmObjectService } from './translate-for-crm-object.service';
import { Observable } from 'rxjs';
import { ActivityType, ObjectType } from '../../tokens-and-interfaces';

@Pipe({
  name: 'translateForCrmObject',

})
export class TranslateForCrmObjectPipe implements PipeTransform {
  constructor(private readonly translateForCrmObjectService: TranslateForCrmObjectService) {}

  transform(value: string, objectType: ObjectType | ActivityType, interpolationParams?: object): Observable<string> {
    return this.translateForCrmObjectService.getTranslationForCrmObject(objectType, value, interpolationParams);
  }
}
